// Модули, включённые у магазина (GET /settings): закупка с биржи (procurement_import_enabled) и т.п.
// По ним фильтруются пункты меню (config/rolePages.js, поле flag) — у Блума и Букетберри вкладки
// «Приёмка» нет. Кэш на сессию, как у catalogLabels.js; null — ещё не загружено.
import { useEffect, useState } from 'react';
import { api } from './api';

let cache = null;
let pending = null;

function fetchFlags() {
  if (cache) return Promise.resolve(cache);
  if (!pending) {
    pending = api.getSettings()
      .then((s) => {
        cache = { procurement_import_enabled: !!s.procurement_import_enabled };
        return cache;
      })
      .catch(() => {
        pending = null;   // не загрузилось — модули выключены, при следующем заходе спросим снова
        return { procurement_import_enabled: false };
      });
  }
  return pending;
}

export function useAppFlags(enabled = true) {
  const [flags, setFlags] = useState(cache);
  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    fetchFlags().then((f) => { if (alive) setFlags(f); });
    return () => { alive = false; };
  }, [enabled]);
  return flags;
}
